module.exports = __webpack_public_path__ + "static/media/HL3.aeeb6f8a.jpg";